var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReorderGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 37.4375C6 34.9842 6 33.7575 6.4823 32.8437C6.79826 32.2452 7.25273 31.7481 7.8 31.4026C8.63539 30.875 9.75691 30.875 12 30.875C14.2431 30.875 15.3646 30.875 16.2 31.4026C16.7473 31.7481 17.2017 32.2452 17.5177 32.8437C18 33.7575 18 34.9842 18 37.4375C18 39.8908 18 41.1175 17.5177 42.0312C17.2017 42.6297 16.7473 43.1269 16.2 43.4724C15.3646 44 14.2431 44 12 44C9.75691 44 8.63539 44 7.8 43.4724C7.25273 43.1269 6.79826 42.6297 6.4823 42.0312C6 41.1175 6 39.8908 6 37.4375Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 37.4375C24 34.9842 24 33.7575 24.4823 32.8437C24.7983 32.2452 25.2528 31.7481 25.8 31.4026C26.6354 30.875 27.757 30.875 30 30.875C32.243 30.875 33.3646 30.875 34.2 31.4026C34.7472 31.7481 35.2018 32.2452 35.5176 32.8437C36 33.7575 36 34.9842 36 37.4375C36 39.8908 36 41.1175 35.5176 42.0312C35.2018 42.6297 34.7472 43.1269 34.2 43.4724C33.3646 44 32.243 44 30 44C27.757 44 26.6354 44 25.8 43.4724C25.2528 43.1269 24.7983 42.6297 24.4823 42.0312C24 41.1175 24 39.8908 24 37.4375Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 37.4375C42 34.9842 42 33.7575 42.4824 32.8437C42.7982 32.2452 43.2528 31.7481 43.8 31.4026C44.6354 30.875 45.757 30.875 48 30.875C50.243 30.875 51.3646 30.875 52.2 31.4026C52.7472 31.7481 53.2018 32.2452 53.5176 32.8437C54 33.7575 54 34.9842 54 37.4375C54 39.8908 54 41.1175 53.5176 42.0312C53.2018 42.6297 52.7472 43.1269 52.2 43.4724C51.3646 44 50.243 44 48 44C45.757 44 44.6354 44 43.8 43.4724C43.2528 43.1269 42.7982 42.6297 42.4824 42.0312C42 41.1175 42 39.8908 42 37.4375Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 30.875V15.125C12 8.93782 12 5.84423 13.7574 3.9221C15.5147 2 18.3432 2 24 2H26.4M36 2C41.6568 2 44.4852 2 46.2427 3.9221C48 5.84423 48 8.93782 48 15.125V23M48 23L52.8 17.75M48 23L43.2 17.75",
    stroke: "#5DEE7A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_30",
    x: 0,
    y: 0,
    width: 60,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderGreen);
export default __webpack_public_path__ + "static/media/reorder-green.d9e4e3c579fff0dbc7f6d31982a940dd.svg";
export { ForwardRef as ReactComponent };